<template>
        <label class="d-block">
            Quality Check Name
            <input v-model="c.name" type="text" class="form-control">
        </label>
        <label class="d-block"><input type="checkbox" v-model="c.default"> Default Proofpoint Check </label>
        <label class="d-block"><input type="checkbox" v-model="c.meta.should_send_to_syndicate"> Should Send to
            Syndicate </label>
        <label class="d-block">
            Proofpoint Config External API ID
            <input v-model="c.meta.external_ids.success_flag" class="form-control"/>
            <small class="text-muted">Will use the config set as default for external APIs in Proofpoint if this field
                is left blank.</small>
        </label>
        <table class="table" v-if="c.statuses">
            <thead>
            <tr>
                <th>Style/Icon</th>
                <!--<th>Key</th>-->
                <th>Name</th>
                <th>Severity</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="s in c.statuses.filter(x => x.severity !== 6)" :key="s.id ? s.id : s.severity">
                <td>
                    <span class="tag" :class="s.tag_class">
                        <i :class="s.icon_class"></i>
                    </span>
                </td>
                <!--<td>{{s.status_key}}</td>-->
                <td><input v-model="s.status_label" class="form-control form-control-sm"/></td>
                <td>{{ getSeverity(s.severity) }}</td>
            </tr>
            </tbody>
        </table>
        <button
            v-if="!isNewCheck"
            type="button"
            @click="handleSave"
            class="btn btn-success mx-2"
            :disabled="networkActivity"
        >
            <spinner v-if="networkActivity" class="d-inline-block"></spinner>
            Save
        </button>
        <button
            v-else
            type="button"
            @click="handleSave"
            class="btn btn-success mx-2"
            :disabled="networkActivity"
        >
            <spinner v-if="networkActivity" class="d-inline-block"></spinner>
            Add check
        </button>
    <hr>
</template>
<script>
import Spinner from "@/components/Controls/Spinner"

export default {
    name: 'QualityCheckForm',
    components: {Spinner},
    props: {
        c: { type: Object, required: true },
        getSeverity: { type: Function, required: true },
        networkActivity: { type: Boolean, default: false },
        save: { type: Function, required: true },
        isNewCheck: { type: Boolean, required: true }
    },
    methods: {
        handleSave() {
            this.save(this.c);
        }
    }
}
</script>
